import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaUserPlus, FaTimes, FaEye } from "react-icons/fa";
import Navbar from "../components/Navbar"; // Import Navbar
import AddEmployeeModal from "../components/AddEmployeeModal"; // Import komponen modal

import "../css/dashboard.css";

const AdminDashboard = () => {
  const [admin, setAdmin] = useState(null);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);
  const [totalPendingTasks, setTotalPendingTasks] = useState(0);
  const [totalInProgressTasks, setTotalInProgressTasks] = useState(0);
  const [totalCompletedTasks, setTotalCompletedTasks] = useState(0);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Handle form input changes
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/register`,
        {
          ...formData,
          business_id: admin.business_id,
        },
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        setTotalEmployees((prev) => prev + 1);
        setShowAddForm(false);
        setFormData({ name: "", email: "", password: "" });
      }
    } catch (err) {
      setError(err.response?.data?.message || "Gagal menambahkan karyawan");
    } finally {
      setLoading(false);
    }
  };

  //   // Modal form component
  //   const AddEmployeeModal = () => (
  //     <div className="modal-overlay">
  //       <div className="add-modal">
  //         <div className="modal-header">
  //           <h3>Tambah Karyawan</h3>
  //           <button className="close-btn" onClick={() => setShowAddForm(false)}>
  //             <FaTimes />
  //           </button>
  //         </div>

  //         <form onSubmit={handleSubmit}>
  //           <div className="form-group">
  //             <label>Nama Lengkap</label>
  //             <input
  //               type="text"
  //               name="name"
  //               value={formData.name}
  //               onChange={handleInputChange}
  //               required
  //             />
  //           </div>

  //           <div className="form-group">
  //             <label>Email</label>
  //             <input
  //               type="email"
  //               name="email"
  //               value={formData.email}
  //               onChange={handleInputChange}
  //               required
  //             />
  //           </div>

  //           <div className="form-group">
  //             <label>Password</label>
  //             <input
  //               type="password"
  //               name="password"
  //               value={formData.password}
  //               onChange={handleInputChange}
  //               required
  //               minLength="6"
  //             />
  //           </div>

  //           {error && <div className="error-message">{error}</div>}

  //           <button type="submit" className="submit-btn" disabled={loading}>
  //             {loading ? "Memproses..." : "Tambahkan"}
  //           </button>
  //         </form>
  //       </div>
  //     </div>
  //   );

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      // Ambil data admin
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/datauser/`, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          const adminData = data.find((user) => user.role === "admin");
          if (adminData) {
            setAdmin(adminData);
            setTotalEmployees(adminData.total_karyawan || 0);
          }
        })
        .catch((err) => {
          console.error("Error fetching admin data:", err);
          if (err.response && err.response.status === 401) {
            localStorage.removeItem("token");
            navigate("/login");
          }
        });

      // Ambil data tugas
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/tasks/`, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          // console.log("Task data:", response.data);

          // Hitung total tugas berdasarkan status
          const tasks = response.data.tasks;
          const totalPending = tasks.filter(
            (task) => task.status === "pending"
          ).length;
          const totalInProgress = tasks.filter(
            (task) => task.status === "in-progress"
          ).length;
          const totalCompleted = tasks.filter(
            (task) => task.status === "completed"
          ).length;

          // Simpan ke state
          setTotalTasks(tasks.length); // Total semua tugas
          setTotalPendingTasks(totalPending); // Total tugas pending
          setTotalInProgressTasks(totalInProgress); // Total tugas diproses
          setTotalCompletedTasks(totalCompleted); // Total tugas selesai
        })
        .catch((err) => {
          console.error("Error fetching task data:", err);
        });
    }
  }, [navigate]);

  return (
    <div className="navbarContainer">
      <Navbar title="Dashboard Admin" />
      <div className="dashboard-container">
        {showAddForm && (
          <AddEmployeeModal
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            setShowAddForm={setShowAddForm}
            loading={loading}
            error={error}
          />
        )}

        <h2>Dashboard Admin</h2>
        {admin && <p>Selamat datang, {admin.name}!</p>}

        <div className="info-box">
          <h3>Total Karyawan</h3>
          <div
            title="klik untuk melihat detail para karyawan"
            className="employee-count"
            onClick={() => console.log("Lihat detail karyawan")}
          >
            <span>{totalEmployees} Karyawan</span>
            <FaEye className="eye-icon" />
          </div>
          <button
            className="add-employee-btn"
            onClick={() => setShowAddForm(true)}
          >
            <FaUserPlus className="add-icon" /> Tambah
          </button>
        </div>

        <div className="task-container">
          <h3>Total Tugas: {totalTasks}</h3>
          <div className="task-status">
            <div className="task-item pending">
              <span>Pending</span>
              <p>{totalPendingTasks}</p>
            </div>
            <div className="task-item in-progress">
              <span>Diproses</span>
              <p>{totalInProgressTasks}</p>
            </div>
            <div className="task-item completed">
              <span>Selesai</span>
              <p>{totalCompletedTasks}</p>
            </div>
          </div>
        </div>

        <button
          className="logout-btn"
          onClick={() => {
            localStorage.removeItem("token");
            navigate("/login");
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
